import React from "react";

const Tile = (props) => {
    const type = props.type || "info";
    const icon = props.icon || "fa fa-user";
    const header = props.header || "...";
    const description = props.description || "";
    const linkText = props.linkText || "More info";
    const linkNavigateTo = props.linkNavigateTo || "/";

    return (
        <div className="col-lg-3 col-6" style={{ padding: "12px" }}>
            <div
                className={"small-box bg-" + type}
                style={{
                    height: "170px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    borderRadius: "6px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                    padding: "18px 0 0 0", // <-- remove left/right padding
                    fontFamily: "inherit",
                }}
            >
                <div style={{ padding: "0 16px" }}>
                    {" "}
                    {/* add horizontal padding only to content */}
                    <div className="inner" style={{ marginBottom: "8px" }}>
                        <span
                            style={{
                                fontSize: "50px",
                                fontWeight: 600,
                                margin: "0 0 6px 0",
                                letterSpacing: "1px",
                                fontFamily: "inherit",
                            }}
                        >
                            {header}
                        </span>
                        <span
                            className="text-small"
                            style={{
                                fontSize: "15px",
                                marginBottom: "4px",
                                display: "block",
                                fontFamily: "inherit",
                            }}
                        >
                            {description}
                        </span>
                    </div>
                    <div
                        className="icon"
                        style={{
                            fontSize: "32px",
                            color: "#fff",
                            opacity: 0.5,
                        }}
                    >
                        <i className={icon} />
                    </div>
                </div>
                <a
                    href={linkNavigateTo}
                    className="small-box-footer"
                    style={{
                        marginTop: "auto",
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "0 0 6px 6px",
                        padding: 0,
                        color: "inherit",
                        fontWeight: 500,
                        textDecoration: "none",
                        fontSize: "15px",
                        letterSpacing: "0.5px",
                        fontFamily: "inherit",
                        minHeight: "38px",
                        height: "38px",
                    }}
                >
                    {linkText}&nbsp;
                    <i className="fas fa-arrow-circle-right" />
                </a>
            </div>
        </div>
    );
};

export default Tile;
